import { createAction, props } from '@ngrx/store';

export const saveEndHours = createAction(
    '[AUTH] save end hours',
    props<{ value: any }>(),
);
